export default "__VITE_ASSET__bffe086a__"